module.exports = __webpack_public_path__ + "img/PlateauofPleasies.0c51ad73.png";